/* CALM · Carro lateral (encargo ronda 3, punto C). 22-oct-2026.
   Complementa al <cart-drawer> de Impact sin reemplazarlo (assets/theme.js no se toca):
   1) «+ Agregar» de las sugerencias (form[data-calm-sug]): mismo flujo que el product-form de Impact y calm-pillow-buy:
      cart:prepare-bundled-sections → POST /cart/add.js con sections → GET /cart.js → variant:add + cart:change{baseEvent:'variant:add'}.
      Impact repinta el cajón y el contador del encabezado. Sin red o sin respuesta JSON: envío normal a /cart/add (lleva a /cart).
   2) −/+ y «Quitar» los sigue manejando Impact (/cart/change.js). Aquí solo se anota a dónde devolver el foco.
   3) Impact reemplaza el HTML del cajón (1250 ms después de cambiar cantidades; al tiro al agregar). Un MutationObserver
      devuelve el foco (−/+ de la misma línea; nombre de la línea siguiente o anterior; título del carro vacío), avisa en el
      role=status del cajón lo que cambió con el total (leído del HTML, sin formatear dinero en JS) y marca en Arena la línea agregada.
   4) Repintado completo (cart:refresh) con DOMParser en vez de div.innerHTML: evita una copia oculta de <cart-drawer> que se
      comía el primer toque y bloqueaba Tab (bug de Impact, ver abajo). Ajuste ronda 2: 22-oct-2026.
   5) «Cambiar al combo» (form[data-calm-combo], decisión del dueño 22-oct-2026): una sola petición POST /cart/update.js
      {colchón: 0, combo: n} con sections y el mismo repintado que «+ Agregar» (variant:add + cart:change{baseEvent:'variant:add'}).
      /cart/update.js no es atómico (combo agotado → 200, sin colchón y carro vacío; sobre el stock → recorta): se revisa el
      carro que vuelve y, si no quedó exacto, se devuelve como estaba ({colchón: q, combo: e}) y se avisa en la tarjeta.
      Mientras corre, el botón queda aria-disabled/aria-busy (no `disabled`, para no perder el foco) y no acepta otro clic.
   6) «−» al tiro (ajustes 5, 23-oct-2026): el «−» de cada línea se habilita o deshabilita en el mismo momento según el valor
      actual del input (habilitado si valor > mínimo), en 'input'/'change', sin esperar el repintado de Impact (~2–3 s).
   7) Una petición de cantidad a la vez (ajustes 5): Impact manda un /cart/change.js por toque sin esperar el anterior y
      Shopify puede aplicarlos en otro orden (medido 23-oct: +,+,− cada 200 ms → pedidos 2,3,2 → el carro quedó en 3).
      Mientras hay una en camino, los toques siguientes (−/+, cantidad escrita, «Quitar») solo se anotan; al volver la
      respuesta se manda UNA vez la cantidad final por el mismo camino de Impact (se re-emite 'change' en el input, o el clic
      en «Quitar»). Nunca más peticiones que toques. Ronda 3: la cantidad pedida se guarda en JS por línea y se vuelve a
      poner tras cada repintado de Impact (que usa el HTML de una respuesta anterior); nunca se manda lo que dice el input.
      6) y 7) van juntos: no quitar 7) dejando 6). Prueba A/B en el borrador (23-oct, 390 px): solo con 6), «+» y «−» a 150 ms
      desde 1 → pedidos 2 y 1 en paralelo → el carro quedó en 2 (se esperaba 1); +,+,− → quedó 1 de más (2 de 2 veces).
      Con 6)+7): 6 de 6 bien, nunca 2 pedidos a la vez. Para volver atrás, reponer el calm-carro.js anterior completo.
   Nunca llama preventDefault en −/+; en «Quitar» solo mientras hay otra petición en camino (7: se manda después por Impact).
   No toca los eventos de la ficha. */
(function () {
  'use strict';
  if (window.__calmCarro) return;
  window.__calmCarro = true;

  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var VIGENCIA = 6000;  /* ms que se espera el repintado de Impact después de una acción */
  var pend = null;      /* acción en curso: {tipo, key, rol, vid, titulo, keys, idx, t0} */
  var nuevos = {};      /* variant id → ms, líneas por marcar en Arena */
  var observado = null, obs = null, cola = 0;
  var flags = { render: false, linea: false };

  function cajon() { return document.getElementById('cart-drawer'); }
  function esc(s) { return String(s).replace(/["\\]/g, '\\$&'); }  /* para valores entre comillas en selectores */
  function abierto(dr) { return !!(dr && dr.hasAttribute('open')); }

  function focoPerdido(dr) {
    var a = document.activeElement;
    return !a || a === document.body || a === document.documentElement || a === dr || !a.isConnected || !dr.contains(a);
  }
  function enfocar(dr, el) {
    if (!el || !abierto(dr) || !focoPerdido(dr)) return;
    try { el.focus(); } catch (e) {}
  }
  function anunciar(dr, msg) {
    var s = dr.querySelector('[data-calm-carro-anuncio]');
    if (!s || !msg) return;
    s.textContent = '';
    setTimeout(function () { s.textContent = msg; }, 80);
  }
  function total(dr) {
    var t = dr.querySelector('[data-calm-total]');
    return t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function datosLinea(dr, li, tipo) {
    var todas = Array.prototype.slice.call(dr.querySelectorAll('line-item[data-key]'));
    return {
      tipo: tipo,
      key: li.getAttribute('data-key'),
      titulo: li.getAttribute('data-calm-titulo') || '',
      keys: todas.map(function (x) { return x.getAttribute('data-key'); }),
      idx: todas.indexOf(li),
      t0: Date.now()
    };
  }

  /* --- Vigilar el cajón (Impact reemplaza su contenido, nunca el elemento; en el editor sí puede cambiar) --- */
  function vigilar() {
    var dr = cajon();
    if (!dr || dr === observado || !window.MutationObserver) return;
    if (obs) obs.disconnect();
    obs = new MutationObserver(alMutar);
    obs.observe(dr, { childList: true, subtree: true });
    observado = dr;
  }
  function alMutar(recs) {
    var dr = observado;
    for (var i = 0; i < recs.length; i++) {
      var t = recs[i].target;
      if (t === dr || (t.classList && t.classList.contains('cart-drawer__inner'))) {
        flags.render = true;
      } else {
        var rem = recs[i].removedNodes;
        for (var j = 0; j < rem.length; j++) {
          if (rem[j].nodeName === 'LINE-ITEM') flags.linea = true;
        }
      }
    }
    /* 7) Al tiro (antes de que el cliente alcance a tocar): el input nuevo muestra la cantidad pedida, no la del HTML viejo. */
    if (flags.render) reaplicar();
    if ((flags.render || flags.linea) && !cola) {
      cola = window.requestAnimationFrame ? window.requestAnimationFrame(procesar) : setTimeout(procesar, 16);
    }
  }

  function marcarNuevas(dr, ahora) {
    Object.keys(nuevos).forEach(function (vid) {
      if (ahora - nuevos[vid] > VIGENCIA) { delete nuevos[vid]; return; }
      var li = dr.querySelector('.cart-drawer__inner line-item[data-variant-id="' + esc(vid) + '"]');
      if (!li) return;
      delete nuevos[vid];
      li.classList.add('calm-cl--nueva');
      setTimeout(function () { li.classList.remove('calm-cl--nueva'); }, 1700);
    });
  }

  function vecina(dr, p) {
    var buscar = function (k) { return k && k !== p.key ? dr.querySelector('line-item[data-key="' + esc(k) + '"]') : null; };
    var li = null, i;
    for (i = p.idx + 1; !li && i < p.keys.length; i++) li = buscar(p.keys[i]);
    for (i = p.idx - 1; !li && i >= 0; i--) li = buscar(p.keys[i]);
    if (!li) li = dr.querySelector('.cart-drawer__inner line-item[data-key]');
    if (li) return li.querySelector('[data-calm-nombre]');
    return dr.querySelector('[data-calm-vacio-titulo]');
  }

  function ponerError(card, msg, alerta) {
    if (!card) return;
    var viejo = card.querySelector('.calm-sug__error');
    if (viejo) viejo.remove();
    var p = document.createElement('p');
    p.className = 'calm-sug__error';
    if (alerta) p.setAttribute('role', 'alert');
    p.textContent = msg;
    card.appendChild(p);
  }

  /* 7) ¿Falta otra respuesta o el repintado de la última? */
  function falta() { return !!vuelo || hayCola() || (Date.now() - tFin < 1150); }

  function procesar() {
    cola = 0;
    var dr = cajon();
    var f = flags;
    flags = { render: false, linea: false };
    if (!dr) return;
    var ahora = Date.now();
    if (f.render) marcarNuevas(dr, ahora);
    if (!pend) return;
    if (ahora - pend.t0 > VIGENCIA) { pend = null; return; }

    /* Quitar: Impact anima y saca la línea antes de repintar; foco provisional en la vecina. */
    if (!f.render) {
      if (f.linea && (pend.tipo === 'quitar' || pend.tipo === 'qty')) {
        var li0 = dr.querySelector('line-item[data-key="' + esc(pend.key) + '"]');
        if (!li0) enfocar(dr, vecina(dr, pend));
      }
      return;
    }

    var p = pend;
    pend = null;
    var tot = total(dr);
    var vacio = !dr.querySelector('.cart-drawer__inner');

    if (p.tipo === 'agregar') {
      var la = dr.querySelector('.cart-drawer__inner line-item[data-variant-id="' + esc(p.vid) + '"]');
      enfocar(dr, la ? la.querySelector('[data-calm-qty="mas"]') : dr.querySelector('[data-calm-cerrar]'));
      anunciar(dr, (p.msg || 'Se agregó ' + p.titulo + ' al carro.') + (tot ? ' Total ' + tot + '.' : ''));
      return;
    }

    if (p.tipo === 'qty') {
      var lq = dr.querySelector('line-item[data-key="' + esc(p.key) + '"]');
      if (lq) {
        var b = p.rol === 'input' ? lq.querySelector('input.quantity-input') : lq.querySelector('[data-calm-qty="' + p.rol + '"]');
        if (b && b.disabled) b = lq.querySelector('[data-calm-qty="mas"]');
        enfocar(dr, b);
        var n = parseInt((lq.querySelector('input.quantity-input') || {}).value, 10);
        /* 7) Toques en cola, o repintado de una respuesta anterior (Impact repinta cada una 1250 ms después; el de la última
           llega ≥ 1250 ms después de tFin): se anuncia en el último. */
        if (falta() || (ultimoCarro && n !== cantEn(ultimoCarro, p.key))) { pend = p; return; }
        if (n > 0) anunciar(dr, p.titulo + ': ' + n + (n === 1 ? ' unidad.' : ' unidades.') + (tot ? ' Total ' + tot + '.' : ''));
        return;
      }
      /* Cantidad 0: la línea salió → igual que «Quitar». */
    }

    enfocar(dr, vecina(dr, p));
    /* Un repintado viejo puede volver a mostrar la línea un momento: el aviso va con el último (carro vacío: Impact repinta al tiro). */
    if (!vacio && falta()) { pend = p; return; }
    anunciar(dr, 'Se quitó ' + p.titulo + ' del carro.' + (vacio ? ' Tu carro está vacío.' : (tot ? ' Total ' + tot + '.' : '')));
  }

  /* --- 2) −/+ y «Quitar»: solo anotar (Impact hace el cambio) --- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var dr = cajon();
    if (!dr || !dr.contains(t)) return;
    vigilar();
    var q = t.closest('[data-calm-qty]');
    if (q) {
      var li = q.closest('line-item');
      if (li && !q.disabled) { pend = datosLinea(dr, li, 'qty'); pend.rol = q.getAttribute('data-calm-qty'); }
      return;
    }
    var r = t.closest('[data-calm-quitar]');
    if (r) {
      var l = r.closest('line-item');
      if (l) pend = datosLinea(dr, l, 'quitar');
    }
  }, true);

  /* Cantidad escrita a mano (el 'change' que dispara Impact al usar −/+ no es isTrusted y ya quedó anotado arriba). */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!e.isTrusted || !t || !t.matches || !t.matches('input.quantity-input[data-line-key]')) return;
    var dr = cajon();
    if (!dr || !dr.contains(t)) return;
    vigilar();
    var li = t.closest('line-item');
    if (li) { pend = datosLinea(dr, li, 'qty'); pend.rol = 'input'; }
  }, true);

  /* --- 6) «−» al tiro: habilitado si el valor actual del input > mínimo (snippets/calm-carro-linea pone el estado inicial). ---
     Va en la fase de burbuja del documento: ya corrieron QuantityInput (normaliza el valor) y LineItemQuantity (envía la
     cantidad), así que no cambia qué se envía. Si Impact rechaza el cambio (p. ej. sin stock) repone el valor anterior sin
     emitir 'change' y avisa con line-item:error: ahí también se sincroniza. Si el «−» tenía el foco y queda deshabilitado,
     el foco pasa al «+» de la misma línea (lo mismo que hace procesar() tras el repintado). */
  function sincronizarMenos(input) {
    var qs = input && input.closest ? input.closest('quantity-selector') : null;
    var menos = qs && qs.querySelector('[data-calm-qty="menos"]');
    if (!menos) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (!(min >= 1)) min = 1;
    var off = !(parseInt(input.value, 10) > min);
    if (menos.disabled === off) return;
    if (off && document.activeElement === menos) {
      var mas = qs.querySelector('[data-calm-qty="mas"]');
      if (mas) { try { mas.focus(); } catch (e) {} }
    }
    menos.disabled = off;
  }
  function alCambiarCantidad(e) {
    var t = e.target;
    if (t && t.matches && t.matches('input.quantity-input[data-line-key]')) sincronizarMenos(t);
  }
  document.addEventListener('input', alCambiarCantidad);
  document.addEventListener('change', alCambiarCantidad);

  /* --- 7) Una petición de cantidad a la vez en el cajón ---
     En camino: desde line-item:will-change (Impact lo emite al empezar cada petición, también «Quitar») hasta line-item:change
     o line-item:error. Se escuchan en ESE mismo <line-item> (Impact los emite ahí aunque ya lo haya sacado al repintar; en
     ese caso no llegan al documento). Reloj de seguridad de 10 s por si la respuesta nunca llega (sin red).
     Mientras hay una en camino, los 'change' de cantidad y el clic en «Quitar» se detienen antes que Impact y quedan en cola.
     La cantidad que quiere el cliente vive en deseo[data-line-key] (ronda 3): al liberar se manda ESE valor, nunca el del
     input, porque Impact repinta el cajón 1250 ms después de cada respuesta con el HTML de esa respuesta (puede ser viejo)
     y pisaba el número en cola (ronda 2: + ×4 cada 450 ms desde 1 → pedidos 2,3,4,2 → el carro quedaba en 2). Tras cada
     repintado se vuelve a poner deseo en el input nuevo (y el «−»), así el siguiente toque parte del número correcto.
     deseo se olvida cuando no queda nada en camino ni en cola y ya pasó el último repintado posible (VIGENTE ms). */
  var vuelo = null;        /* petición en camino: {key, li} (una sola a la vez) */
  var reloj = 0, ultimoCarro = null;
  var tFin = 0;            /* ms de la última respuesta: Impact repinta 1250 ms después */
  var VIGENTE = 2750;      /* 1250 ms + margen por si el navegador atrasa el repintado */
  var deseo = {};          /* data-line-key → cantidad que pidió el cliente (0 = «Quitar» en cola) */
  var enCola = {};         /* data-line-key → true: toque guardado mientras había una petición en camino */
  var tiene = Object.prototype.hasOwnProperty;
  function hayCola() { for (var k in enCola) if (tiene.call(enCola, k)) return true; return false; }
  function vigente() { return !!vuelo || hayCola() || (Date.now() - tFin < VIGENTE); }
  function inputDe(key) {
    var dr = cajon();
    var ins = dr ? dr.querySelectorAll('input.quantity-input[data-line-key]') : [];
    for (var i = 0; i < ins.length; i++) if (ins[i].getAttribute('data-line-key') === key) return ins[i];
    return null;
  }
  function quitarDe(key) {
    var dr = cajon();
    var ls = dr ? dr.querySelectorAll('line-item[data-key]') : [];
    for (var i = 0; i < ls.length; i++) if (ls[i].getAttribute('data-key') === key) return ls[i].querySelector('a[data-calm-quitar]');
    return null;
  }
  function cantEn(cart, key) {
    var it = (cart && cart.items) || [];
    for (var i = 0; i < it.length; i++) if (it[i].key === key) return it[i].quantity;
    return 0;
  }
  /* Mismo límite que QuantityInput de Impact (mínimo, o 1; máximo si hay). */
  function acotar(inp, n) {
    var min = parseInt(inp.getAttribute('min'), 10), max = parseInt(inp.getAttribute('max'), 10);
    if (!(min >= 1)) min = 1;
    if (!(n >= min)) n = min;
    if (max >= min && n > max) n = max;
    return n;
  }
  function ponerValor(inp, n) {
    if (String(inp.value) !== String(n)) inp.value = String(n);
    sincronizarMenos(inp);
  }
  /* Tras un repintado de Impact (o una respuesta): el input muestra lo que pidió el cliente, no el HTML viejo. */
  function reaplicar() {
    if (!vigente()) { deseo = {}; return; }
    for (var key in deseo) {
      if (!tiene.call(deseo, key) || !(deseo[key] > 0)) continue;
      var inp = inputDe(key);
      if (inp && parseInt(inp.value, 10) !== deseo[key]) ponerValor(inp, deseo[key]);
    }
  }
  /* Manda lo que quedó en cola: una línea por respuesta, con la cantidad de deseo, por el mismo camino de Impact. */
  function liberar(cart) {
    var keys = Object.keys(enCola);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      delete enCola[key];
      var n = deseo[key];
      if (!(n >= 0)) continue;
      if (cart && cantEn(cart, key) === 0) { delete deseo[key]; continue; }   /* la línea ya no está */
      var inp = inputDe(key);
      if (cart && cantEn(cart, key) === n) { if (inp) ponerValor(inp, n); continue; }  /* ya quedó así: nada que mandar */
      if (n === 0) {
        var a = quitarDe(key);
        if (!a) { delete deseo[key]; continue; }
        a.click();   /* Impact: _onRemoveLinkClicked → /cart/change.js {quantity: 0} */
      } else {
        if (!inp) { delete deseo[key]; continue; }
        inp.value = String(n);
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (vuelo) return;  /* las demás líneas en cola esperan esta respuesta */
    }
  }
  function terminar(v, cart, error) {
    if (vuelo !== v) return;
    vuelo = null;
    if (reloj) { clearTimeout(reloj); reloj = 0; }
    tFin = Date.now();
    var key = v.key;
    if (cart && cart.items) ultimoCarro = cart;
    if (key && error) {
      /* Shopify no aceptó el cambio (p. ej. sin stock): el carro no cambió. Se descarta la cola de esa línea y se muestra lo
         que hay en el carro (o lo que repuso Impact si aún no hay carro conocido). */
      delete enCola[key];
      var real = ultimoCarro ? cantEn(ultimoCarro, key) : 0;
      if (!(real > 0)) real = parseInt(((v.li && v.li.querySelector('input.quantity-input')) || {}).value, 10);
      if (real > 0) {
        deseo[key] = real;
        var ie = inputDe(key);
        if (ie) ponerValor(ie, real);
      } else delete deseo[key];
    } else if (key && cart && !enCola[key]) {
      /* Sin toques nuevos en esa línea: vale lo que quedó en el carro (Shopify puede recortar al stock). */
      var q = cantEn(cart, key);
      if (q > 0) deseo[key] = q; else delete deseo[key];
    }
    liberar(cart || (error ? ultimoCarro : null));
    reaplicar();
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!vuelo || !t || !t.matches || !t.matches('input.quantity-input[data-line-key]')) return;
    var dr = cajon();
    if (!dr || !dr.contains(t)) return;
    e.stopImmediatePropagation();
    var n = acotar(t, parseInt(t.value, 10));
    deseo[t.getAttribute('data-line-key')] = n;
    enCola[t.getAttribute('data-line-key')] = true;
    ponerValor(t, n);
  }, true);
  /* «Quitar» mientras hay una petición en camino: se guarda y se manda después (si no, iría en paralelo y podría perderse). */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!vuelo || !t || t.tagName !== 'A' || !t.hasAttribute('data-calm-quitar')) return;
    var dr = cajon();
    var li = t.closest ? t.closest('line-item[data-key]') : null;
    if (!dr || !li || !dr.contains(li)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    deseo[li.getAttribute('data-key')] = 0;
    enCola[li.getAttribute('data-key')] = true;
  }, true);
  document.addEventListener('line-item:will-change', function (e) {
    var dr = cajon(), li = e.target;
    if (!dr || !li || !li.getAttribute || !dr.contains(li)) return;
    var key = li.getAttribute('data-key');
    var q = e.detail ? e.detail.targetQuantity : NaN;
    if (!vigente()) deseo = {};
    if (key && typeof q === 'number' && q >= 0) deseo[key] = q;
    var v = { key: key, li: li };
    vuelo = v;
    function soltar() { li.removeEventListener('line-item:change', alCambio); li.removeEventListener('line-item:error', alError); }
    /* Impact emite cart:change justo después de line-item:change: se libera al terminar eso (microtarea). */
    function alCambio(ev) { soltar(); var c = ev.detail && ev.detail.cart; Promise.resolve().then(function () { terminar(v, c, false); }); }
    function alError() { soltar(); Promise.resolve().then(function () { terminar(v, null, true); }); }
    li.addEventListener('line-item:change', alCambio);
    li.addEventListener('line-item:error', alError);
    if (reloj) clearTimeout(reloj);
    reloj = setTimeout(function () { reloj = 0; soltar(); terminar(v, null, false); }, 10000);
  });
  document.addEventListener('cart:change', function (e) {
    var d = e.detail || {};
    if (d.cart && d.cart.items) ultimoCarro = d.cart;
    if (d.baseEvent !== 'line-item:change') olvidarLibres();
  });
  document.addEventListener('cart:refresh', olvidarLibres);
  /* El carro cambió por otro camino (agregar, cambiar al combo, repintado completo): su HTML manda en las líneas sin
     nada pendiente. */
  function olvidarLibres() {
    for (var key in deseo) {
      if (tiene.call(deseo, key) && !enCola[key] && !(vuelo && vuelo.key === key)) delete deseo[key];
    }
  }

  /* Ficha de producto, calm-pillow-buy y sugerencias: marcar en Arena lo recién agregado (no mueve el foco). */
  document.addEventListener('variant:add', function (e) {
    vigilar();
    var items = (e.detail && e.detail.items) || [];
    var ahora = Date.now();
    for (var i = 0; i < items.length; i++) {
      var v = items[i] && (items[i].variant_id || items[i].id);
      if (v) nuevos[String(v)] = ahora;
    }
  });

  /* --- 1) «+ Agregar» de las sugerencias --- */
  function agregar(f) {
    var btn = f.querySelector('[type="submit"]');
    var idEl = f.querySelector('[name="id"]');
    var vid = idEl ? String(idEl.value) : '';
    var titulo = f.getAttribute('data-calm-titulo') || '';
    var card = f.closest('[data-calm-sug-card]');
    f.setAttribute('data-calm-ocupado', '1');
    if (btn) btn.setAttribute('aria-busy', 'true');
    function listo() { f.removeAttribute('data-calm-ocupado'); if (btn) btn.removeAttribute('aria-busy'); }
    function nativo() { listo(); HTMLFormElement.prototype.submit.call(f); }
    function alCarro() { listo(); window.location.href = raiz + 'cart'; }

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var fd = new FormData(f);
    fd.set('sections', sections.join(','));
    fd.set('sections_url', raiz + 'variants/' + vid);
    vigilar();

    fetch(raiz + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        return res.json().then(function (j) { return { ok: res.ok, json: j }; }, function () { return { ok: res.ok, json: null }; });
      }, function () { return null; })
      .then(function (r) {
        if (!r) { nativo(); return; }                 /* sin red: no llegó a Shopify → envío normal */
        if (!r.ok) {
          if (!r.json) { nativo(); return; }          /* 429 / desafío sin JSON: no se agregó → envío normal */
          listo();
          var msg = (typeof r.json.description === 'string' && r.json.description) ||
                    (typeof r.json.message === 'string' && r.json.message) || 'No se pudo agregar. Inténtalo de nuevo.';
          /* El carro no cambió: solo se muestra el aviso de Shopify en la tarjeta (sin cart:refresh; el foco sigue en el botón). */
          ponerError(card, msg, true);
          return;
        }
        if (!r.json || !r.json.sections) { alCarro(); return; }   /* se agregó, pero sin HTML del cajón: mostrar /cart */
        return fetch(raiz + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (x) { return x.json(); })
          .then(function (cart) {
            cart.sections = r.json.sections;
            var items = Object.prototype.hasOwnProperty.call(r.json, 'items') ? r.json.items : [r.json];
            listo();
            /* En la página /cart Impact recarga en vez de repintar (igual que su product-form). */
            var tv = window.themeVariables;
            if (tv && tv.settings && tv.settings.pageType === 'cart') { window.location.href = raiz + 'cart'; return; }
            pend = { tipo: 'agregar', vid: vid, titulo: titulo, t0: Date.now() };
            f.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
          }, alCarro);
      })
      .catch(function () { if (f.getAttribute('data-calm-ocupado')) alCarro(); });
  }

  /* --- 5) «Cambiar al combo» --- */
  function cambiar(f) {
    var btn = f.querySelector('[type="submit"]');
    var vm = f.getAttribute('data-calm-vm'), vc = f.getAttribute('data-calm-vc');
    var q = parseInt(f.getAttribute('data-calm-q'), 10), e0 = parseInt(f.getAttribute('data-calm-e'), 10) || 0;
    var n = e0 + q;
    var titulo = f.getAttribute('data-calm-titulo') || '';
    var card = f.closest('[data-calm-sug-card]');
    if (!vm || !vc || !(q > 0)) return;
    var INTACTO = 'No se pudo cambiar al combo. Tu carro no cambió.';
    f.setAttribute('data-calm-ocupado', '1');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.setAttribute('aria-disabled', 'true'); }
    function listo() {
      f.removeAttribute('data-calm-ocupado');
      if (btn) { btn.removeAttribute('aria-busy'); btn.removeAttribute('aria-disabled'); }
    }
    function cant(cart, vid) {
      var t = 0, it = (cart && cart.items) || [];
      for (var i = 0; i < it.length; i++) if (String(it[i].variant_id) === vid) t += it[i].quantity;
      return t;
    }
    function esCarro(j) { return !!(j && Object.prototype.toString.call(j.items) === '[object Array]'); }
    function destino(c) { return cant(c, vm) === 0 && cant(c, vc) === n; }
    function original(c) { return cant(c, vm) === q && cant(c, vc) === e0; }
    function fallo(msg) { listo(); ponerError(card, msg, true); }

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    function enviar(cambios) {
      var u = {};
      u[vm] = cambios[0];
      u[vc] = cambios[1];
      return fetch(raiz + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: u, sections: sections, sections_url: raiz + 'variants/' + vc })
      }).then(function (res) {
        return res.json().then(function (j) { return { ok: res.ok, json: j }; }, function () { return { ok: res.ok, json: null }; });
      }, function () { return null; });
    }
    function leerCarro() {
      return fetch(raiz + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (x) { return x.ok ? x.json() : null; })
        .then(function (c) { return esCarro(c) ? c : null; }, function () { return null; });
    }
    function exito(cart) {
      listo();
      var tv = window.themeVariables;
      if (tv && tv.settings && tv.settings.pageType === 'cart') { window.location.href = raiz + 'cart'; return; }
      pend = { tipo: 'agregar', vid: vc, titulo: titulo, msg: 'Cambiado al ' + titulo + '.', t0: Date.now() };
      if (!cart.sections) { document.dispatchEvent(new CustomEvent('cart:refresh')); return; }
      var items = cart.items.filter(function (x) { return String(x.variant_id) === vc; });
      f.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
    }
    /* No quedó exacto: devolver el carro a como estaba. Si tampoco se puede, mostrar el carro real. */
    function revertir(desc) {
      return enviar([q, e0]).then(function (r2) {
        var c3 = r2 && r2.ok && esCarro(r2.json) ? r2.json : null;
        if (c3 && original(c3)) { fallo(desc || INTACTO); return; }
        listo();
        pend = null;
        if (c3 && c3.sections) document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: c3 } }));
        else document.dispatchEvent(new CustomEvent('cart:refresh'));
        var dr = cajon();
        if (dr) anunciar(dr, 'No se pudo cambiar al combo. Revisa tu carro.');
      });
    }

    vigilar();
    enviar([0, n])
      .then(function (r) {
        var c = r && r.ok && esCarro(r.json) ? r.json : null;
        if (c && destino(c)) { exito(c); return; }
        var desc = r && !r.ok && r.json && ((typeof r.json.description === 'string' && r.json.description) ||
                   (typeof r.json.message === 'string' && r.json.message)) || '';
        return (c ? Promise.resolve(c) : leerCarro()).then(function (c2) {
          if (!c2) { fallo(desc || 'No se pudo cambiar al combo. Inténtalo de nuevo.'); return; }
          if (destino(c2)) { exito(c2); return; }          /* se cambió aunque la respuesta no sirvió: repintado completo */
          if (original(c2)) { fallo(desc || INTACTO); return; }
          return revertir(desc);
        });
      })
      .catch(function () { if (f.getAttribute('data-calm-ocupado')) fallo('No se pudo cambiar al combo. Revisa tu carro.'); });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.hasAttribute || !(f.hasAttribute('data-calm-sug') || f.hasAttribute('data-calm-combo'))) return;
    var dr = cajon();
    if (!dr || !dr.contains(f)) return;
    var tv = window.themeVariables;
    if (!window.fetch || !window.FormData || !window.CustomEvent || !window.Promise) return;
    if (!(tv && tv.settings && tv.settings.cartType === 'drawer' && window.customElements && window.customElements.get('cart-drawer'))) return;
    e.preventDefault();
    if (f.getAttribute('data-calm-ocupado')) return;
    if (f.hasAttribute('data-calm-combo')) cambiar(f);
    else agregar(f);
  });

  /* --- 4) Arreglo de un bug de Impact que también tiene el tema en vivo (assets/theme.js no se toca) ---
     El repintado completo del cajón (cart:refresh: al volver con «atrás» desde bfcache, si falla «Añadir» en la ficha o al
     aplicar un descuento) parsea la sección con div.innerHTML. Ese div suelto crea una copia viva y oculta de <cart-drawer>,
     que también escucha el ícono del carro: al abrirlo, su trampa de foco se come el primer toque y deja Tab sin moverse
     (medido el 22-oct: tras cart:refresh el 1er toque en «+» no hacía nada). Se cambia solo esa función por la misma con
     DOMParser, como Impact ya hace en cart:change: no crea elementos vivos y el resultado es idéntico. */
  function arreglarRefresh() {
    var C = window.customElements && window.customElements.get('cart-drawer');
    if (!C || !window.DOMParser || !window.fetch) return;
    var proto = C.prototype;
    if (!proto.__calmRefresh && typeof proto._onCartRefresh === 'function') {
      proto.__calmRefresh = true;
      proto._onCartRefresh = function () {
        var self = this;
        var sec = self.closest('.shopify-section');
        if (!sec || !sec.id) return Promise.resolve();
        return fetch(raiz + '?section_id=' + sec.id.replace('shopify-section-', ''))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart-drawer');
            if (nuevo) self.replaceChildren.apply(self, Array.prototype.slice.call(nuevo.children));
          });
      };
    }
    /* El cajón ya creado guardó la función vieja enlazada en su listener de cart:refresh: se cambia por la nueva.
       (El de «pageshow» la busca en el prototipo cada vez, así que ya usa la nueva.) */
    var dr = cajon();
    if (dr && dr instanceof C && dr.isConnected && !dr.__calmRefreshCajon && dr._onCartRefreshListener) {
      dr.__calmRefreshCajon = true;
      document.removeEventListener('cart:refresh', dr._onCartRefreshListener);
      dr._onCartRefreshListener = dr._onCartRefresh.bind(dr);
      document.addEventListener('cart:refresh', dr._onCartRefreshListener);
    }
  }
  if (window.customElements && window.customElements.get('cart-drawer')) arreglarRefresh();
  else if (window.customElements && window.customElements.whenDefined) window.customElements.whenDefined('cart-drawer').then(arreglarRefresh);

  vigilar();
})();
